export function buildWorkspaceFields(workspaceInfo: any): any {
	return {
		workspaceId: workspaceInfo.workspaceId,
	};
}
